import React from "react";

const OurTeam = () => {
  return (
    <div>
      <h1>OurTeam Page</h1>
    </div>
  );
};

export default OurTeam;
